import React, { useEffect, useState } from 'react';
import DiagnosticsFixedColumnTable from './components/DiagnosticsFixedColumnTable';

const ShowMetadata = (props) => {
  const { rows, columns, csDiagnostics, onLoadMetadata, onStartMetadata, onStopMetadata } = props;
  const [searchValues, setSearchValues] = useState({});
  const [globalSearchValue, setGlobalSearchValue] = useState('');

  useEffect(() => {
    setSearchValues({});
    setGlobalSearchValue('');
  }, [rows, columns]);

  const handleColumnFilterChange = (e, key) => {
    setSearchValues((prev) => ({
      ...prev,
      [key]: e.target.value.toLowerCase(),
    }));
  };

  const metadataHeaderActions = (
    <>
      <button type="button" className="btn btn-sm btn-voltup-theme" onClick={onLoadMetadata}>
        Load Metadata
      </button>
      <button type="button" className="btn btn-sm btn-voltup-theme" onClick={onStartMetadata}>
        Start Metadata
      </button>
      <button type="button" className="btn btn-sm btn-voltup-theme" onClick={onStopMetadata}>
        Stop Metadata
      </button>
    </>
  );

  return (
    <DiagnosticsFixedColumnTable
      title="METADATA"
      columns={columns}
      rows={rows}
      searchValues={searchValues}
      onColumnFilterChange={handleColumnFilterChange}
      globalSearchValue={globalSearchValue}
      onGlobalSearchChange={(e) => setGlobalSearchValue(e.target.value)}
      tableId="metadata"
      exportTableKey="metadata"
      csDiagnostics={csDiagnostics}
      allExportRows={rows}
      fixedHeight={420}
      extraHeaderActions={metadataHeaderActions}
    />
  );
};

export default ShowMetadata;
